export const DEFAULT_PAGE = 1;

export const ITEM_TYPE = {
  PAGE: 'page',
  NEXT: 'next',
  PREV: 'prev',
};
